import {BrowserRouter as Router, Route, Routes} from "react-router";
import {AuthProvider, useAuth} from "./components/context/AuthContext.jsx";
import PrivateRoute from "./components/login/PrivateRoute.jsx";
import { Provider } from "react-redux";
import store from "./components/redux/store";
import Login from "./components/login/login";
import ObjekteListe from "./components/main/ObjekteListe";
import ObjekteListePrint from "./components/main/ObjekteListePrint";
import ObjektDetail from './components/main/ObjektDetail';
import ObjektErstellen from "./components/main/ObjektErstellen";
import DashboardView from "./components/dashboard/DashboardView";
import KPIBoard from "./components/dashboard/KPIBoard";
import ObjekteListeWrapper from "./components/dashboard/ObjekteListeWrapper";
import AdminPanel from "./components/admin/AdminPanel";
import MandantErstellen from "./components/utils/MandantErstellen";
import Profil from "./components/login/Profil"
import KategorienListe from "./components/masterdata/KategorienListe";
import AblageorteListe from "./components/masterdata/AblageorteListe";
import TypenListe from "./components/masterdata/TypenListe";
import LaenderListe from "./components/masterdata/LaenderListe";
import MaterialienListe from "./components/masterdata/MaterialienListe";
import WaehrungenListe from "./components/masterdata/WaehrungenListe";
import ZustaendeListe from "./components/masterdata/ZustaendeListe";
import EigentuemerListe from "./components/masterdata/EigentuemerListe";
import Zwischenmomenten from "./components/gallery/Zwischenmomenten.jsx";

import './App.css';

function App() {
  return(
    <Provider store={store}>
      <Router>
        <AuthProvider>
            <Routes>
                <Route path="/" element={<Main />} />

                <Route path="/objekte" element={
                    <PrivateRoute>
                        <ObjekteListe />
                    </PrivateRoute>
                } />

                <Route path="/:id" element={
                    <PrivateRoute>
                        <ObjektDetail />
                    </PrivateRoute>
                } />

                <Route path="/add" element={
                    <PrivateRoute>
                        <ObjektErstellen />
                    </PrivateRoute>
                } />

                <Route path="/dashboard" element={
                    <PrivateRoute>
                        <ObjekteListeWrapper>
                        {(objekte, { kategorien, ablageorte, typen, laender, materialien, waehrungen, zustaende, eigentuemer }) => (
                            <DashboardView
                              objekte={objekte}
                              kategorien={kategorien}
                              ablageorte={ablageorte}
                              typen={typen}
                              laender={laender}
                              materialien={materialien}
                              waehrungen={waehrungen}
                              zustaende={zustaende}
                              eigentuemer={eigentuemer}
                            />
                          )}
                        </ObjekteListeWrapper>
                    </PrivateRoute>
                } />
                <Route path="/dashboard/kpi" element={
                    <PrivateRoute>
                        <KPIBoard />
                    </PrivateRoute>
                } />
                <Route path="/objekte/print" element={
                    <PrivateRoute>
                        <ObjekteListePrint />
                    </PrivateRoute>
                } />
                <Route path="/admin" element={
                    <PrivateRoute>
                        <AdminPanel />
                    </PrivateRoute>
                } />
                <Route path="/admin/mandant-anlegen" element={
                    <PrivateRoute>
                        <MandantErstellen />
                    </PrivateRoute>
                } />
                <Route path="/kategorien_api" element={
                    <PrivateRoute>
                        <KategorienListe />
                    </PrivateRoute>} />
                <Route path="/ablageorte_api" element={
                    <PrivateRoute>
                        <AblageorteListe />
                    </PrivateRoute>
                } />
                <Route path="/typen_api" element={
                    <PrivateRoute>
                        <TypenListe />
                    </PrivateRoute>
                } />
                <Route path="/laender_api" element={
                    <PrivateRoute>
                        <LaenderListe />
                    </PrivateRoute>
                } />
                <Route path="/materialien_api" element={
                    <PrivateRoute>
                        <MaterialienListe />
                    </PrivateRoute>
                } />
                <Route path="/waehrungen_api" element={
                    <PrivateRoute>
                        <WaehrungenListe />
                    </PrivateRoute>
                } />
                <Route path="/zustaende_api" element={
                    <PrivateRoute>
                        <ZustaendeListe />
                    </PrivateRoute>
                } />
                <Route path="/eigentuemer_api" element={
                    <PrivateRoute>
                        <EigentuemerListe />
                    </PrivateRoute>
                } />
                <Route path="/profil" element={
                    <PrivateRoute>
                        <Profil />
                    </PrivateRoute>
                } />
                <Route
                    path="/zwischenmomenten"
                    element={<Zwischenmomenten />}
                />
            </Routes>
        </AuthProvider>
      </Router>
    </Provider>

  )
}

const Main = () => {
    const { handleLogin, handleLogout } = useAuth();

    return (
        <div className="login-page" align="center">
            <Login handleLogin={handleLogin} handleLogout={handleLogout}/>
        </div>
    );
};

export default App;
